import { render, staticRenderFns } from "./TreatmentDetail.vue?vue&type=template&id=7540d510&scoped=true&lang=pug"
import script from "./TreatmentDetail.vue?vue&type=script&lang=js"
export * from "./TreatmentDetail.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDetail.vue?vue&type=style&index=0&id=7540d510&prod&lang=scss&scoped=true"
import style1 from "./TreatmentDetail.vue?vue&type=style&index=1&id=7540d510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7540d510",
  null
  
)

export default component.exports